<template>
    <div class="w-page">
        <!-- Desktop Version -->
        <div v-if="$web.isDesktop" class="desktop-page">
            <div class="wrapper">
                <header class="page-header">
                    <div class="container">
                        <div class="d-flex justify-content-between">
                            <div class="logo">
                                <a href="#" @click.prevent="goHome">
                                    <img src="../assets/logo-white-inline.svg" alt="Lire">
                                </a>
                            </div>

                            <div class="actions">
                                <button class="navbar-toggler" type="button" @click.prevent="toggleMenu">
                                    <span class="navbar-toggler-icon"></span>
                                </button>
                                <div class="menu-dropdown" :class="{'show': showDropdownMenu}">
                                    <a :href="$options.consts.VUE_APP_WEBSITE" class="btn btn-link mr-1">
                                        Vai al sito
                                    </a>
                                    <a href="#" class="btn btn-primary mr-1" @click.prevent="goHome">
                                        Nuova analisi
                                    </a>
                                    <a href="#" class="btn btn-secondary mr-1" @click.prevent="login" v-if="!loggedIn">
                                        Accedi
                                        <svg width="20" height="20" viewBox="0 0 20 20"
                                             xmlns="http://www.w3.org/2000/svg"
                                             class="user-icon">
                                            <path d="M10 0.25C4.96094 0.25 0.817187 4.07031 0.30625 8.97344C0.26875 9.31094 0.25 9.65312 0.25 10C0.25 10.3469 0.26875 10.6891 0.30625 11.0266C0.817187 15.9297 4.96094 19.75 10 19.75C15.3859 19.75 19.75 15.3859 19.75 10C19.75 4.61406 15.3859 0.25 10 0.25ZM16.3656 15.5359C15.3016 15.1328 13.5766 14.5422 12.5031 14.2234C12.3906 14.1906 12.3766 14.1812 12.3766 13.7219C12.3766 13.3422 12.5312 12.9578 12.6859 12.6297C12.8547 12.2781 13.0469 11.6828 13.1172 11.1484C13.3141 10.9187 13.5859 10.4688 13.7547 9.60625C13.9047 8.84688 13.8344 8.57031 13.7359 8.3125C13.7266 8.28438 13.7125 8.25625 13.7078 8.23281C13.6703 8.05469 13.7219 7.13125 13.8531 6.41406C13.9422 5.92188 13.8297 4.87656 13.1547 4.00937C12.7281 3.46094 11.9078 2.79062 10.4125 2.69687H9.59219C8.12031 2.79062 7.30469 3.46094 6.87344 4.00937C6.19375 4.87656 6.08125 5.92188 6.17031 6.41406C6.30156 7.13125 6.35312 8.05469 6.31562 8.23281C6.30625 8.26562 6.29688 8.28906 6.2875 8.31719C6.18906 8.575 6.11406 8.85156 6.26875 9.61094C6.44219 10.4734 6.70937 10.9234 6.90625 11.1531C6.97656 11.6875 7.17344 12.2781 7.3375 12.6344C7.45937 12.8922 7.51562 13.2437 7.51562 13.7406C7.51562 14.2047 7.49687 14.2094 7.39375 14.2422C6.28281 14.5703 4.63281 15.1516 3.64375 15.5453C2.29375 14.0031 1.5625 12.0578 1.5625 10C1.5625 7.74531 2.43906 5.62656 4.03281 4.03281C5.62656 2.43906 7.74531 1.5625 10 1.5625C12.2547 1.5625 14.3734 2.43906 15.9672 4.03281C17.5609 5.62656 18.4375 7.74531 18.4375 10C18.4375 12.0578 17.7062 14.0031 16.3656 15.5359Z"/>
                                        </svg>
                                    </a>
                                    <a href="#" v-if="loggedIn" @click.prevent="exit()"
                                       class="btn btn-secondary">
                                        Esci
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>
                <div class="container">
                    <router-view></router-view>
                </div>
            </div>
            <footer class="sticky-footer">
                <div class="container">
                    <div class="pre-footer d-flex justify-content-between flex-wrap">
                        <div class="downloads mb-3" style="white-space: nowrap">
                            <a :href="$options.consts.VUE_APP_APP_STORE" @click="downloadFromAppStore"
                               v-if="$options.consts.VUE_APP_APP_STORE" target="_blank">
                                <img src="../assets/app-store.png" alt="App Store">
                            </a>
                            <a :href="$options.consts.VUE_APP_PLAY_STORE" @click="downloadFromPlayStore"
                               v-if="$options.consts.VUE_APP_PLAY_STORE" target="_blank">
                                <img src="../assets/play-store.png" alt="Play Store">
                            </a>
                        </div>
                        <div class="socials text-center mb-3" style="white-space: nowrap">
                            <a :href="$options.consts.VUE_APP_FACEBOOK_LINK" v-if="$options.consts.VUE_APP_FACEBOOK_LINK" target="_blank">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.9"
                                          d="M11.3856 0.661607V11.3357C11.3856 11.7027 11.1035 11.9973 10.7579 11.9973H7.85557V7.35268H9.33468L9.55579 5.54196H7.85303V4.38482C7.85303 3.85982 7.99027 3.50357 8.70441 3.50357H9.61424V1.88304C9.45667 1.86161 8.91789 1.81071 8.28761 1.81071C6.97623 1.81071 6.07657 2.65446 6.07657 4.20536V5.54196H4.59237V7.35268H6.07657V12H0.627734C0.282099 12 0 11.7027 0 11.3384V0.661607C0 0.297321 0.282099 0 0.627734 0H10.7553C11.1035 0 11.3856 0.297321 11.3856 0.661607Z"/>
                                </svg>
                            </a>
                            <a :href="$options.consts.VUE_APP_TWITTER_LINK" v-if="$options.consts.VUE_APP_TWITTER_LINK" target="_blank">
                                <svg width="13" height="10" viewBox="0 0 13 10" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.9"
                                          d="M11.5893 2.49218C11.5971 2.60155 11.5971 2.71094 11.5971 2.82031C11.5971 6.15623 9.06861 10 4.4472 10C3.02343 10 1.70082 9.58592 0.588257 8.8672C0.790547 8.89062 0.985031 8.89844 1.1951 8.89844C2.36988 8.89844 3.45134 8.50001 4.31493 7.82032C3.21016 7.79688 2.28432 7.07032 1.96533 6.07031C2.12094 6.09373 2.27653 6.10936 2.43993 6.10936C2.66555 6.10936 2.89119 6.0781 3.10124 6.02344C1.94978 5.78905 1.08616 4.77343 1.08616 3.54687V3.51563C1.4207 3.70313 1.80974 3.82032 2.22205 3.83593C1.54518 3.38279 1.10173 2.60936 1.10173 1.73436C1.10173 1.26562 1.22619 0.835928 1.44405 0.460926C2.68109 1.99217 4.54055 2.99216 6.6256 3.10155C6.58671 2.91405 6.56336 2.71876 6.56336 2.52344C6.56336 1.1328 7.68371 0 9.07634 0C9.79989 0 10.4534 0.304687 10.9125 0.796875C11.4804 0.687505 12.025 0.476557 12.5074 0.187501C12.3206 0.773452 11.9239 1.26564 11.4026 1.57812C11.9083 1.52346 12.3985 1.3828 12.8497 1.18751C12.5074 1.68749 12.0795 2.13278 11.5893 2.49218Z"/>
                                </svg>
                            </a>
                            <a :href="$options.consts.VUE_APP_INSTAGRAM_LINK" v-if="$options.consts.VUE_APP_INSTAGRAM_LINK" target="_blank">
                                <svg width="13" height="12" viewBox="0 0 13 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.9"
                                          d="M6.66804 2.92335C4.92832 2.92335 3.52506 4.297 3.52506 6C3.52506 7.703 4.92832 9.07665 6.66804 9.07665C8.40775 9.07665 9.81101 7.703 9.81101 6C9.81101 4.297 8.40775 2.92335 6.66804 2.92335ZM6.66804 8.00022C5.54379 8.00022 4.62469 7.1032 4.62469 6C4.62469 4.8968 5.54105 3.99978 6.66804 3.99978C7.79502 3.99978 8.71138 4.8968 8.71138 6C8.71138 7.1032 7.79229 8.00022 6.66804 8.00022ZM10.6727 2.7975C10.6727 3.19647 10.3444 3.51512 9.93958 3.51512C9.532 3.51512 9.20649 3.1938 9.20649 2.7975C9.20649 2.40121 9.53474 2.07988 9.93958 2.07988C10.3444 2.07988 10.6727 2.40121 10.6727 2.7975ZM12.7543 3.52583C12.7078 2.56454 12.4835 1.71304 11.7641 1.01149C11.0474 0.309941 10.1776 0.0903715 9.19555 0.0421734C8.18345 -0.0140578 5.14989 -0.0140578 4.13779 0.0421734C3.15852 0.0876939 2.28866 0.307263 1.56925 1.00881C0.849837 1.71036 0.62827 2.56187 0.579032 3.52315C0.521589 4.51389 0.521589 7.48343 0.579032 8.47417C0.625534 9.43546 0.849837 10.287 1.56925 10.9885C2.28866 11.6901 3.15578 11.9096 4.13779 11.9578C5.14989 12.0141 8.18345 12.0141 9.19555 11.9578C10.1776 11.9123 11.0474 11.6927 11.7641 10.9885C12.4808 10.287 12.7051 9.43546 12.7543 8.47417C12.8117 7.48343 12.8117 4.51657 12.7543 3.52583ZM11.4468 9.53721C11.2334 10.062 10.8204 10.4664 10.2815 10.6779C9.47456 10.9912 7.55978 10.9189 6.66804 10.9189C5.7763 10.9189 3.85878 10.9885 3.05457 10.6779C2.51843 10.469 2.10539 10.0647 1.88929 9.53721C1.56925 8.74729 1.6431 6.87292 1.6431 6C1.6431 5.12708 1.57198 3.25003 1.88929 2.46279C2.10265 1.93797 2.5157 1.53364 3.05457 1.3221C3.86151 1.00881 5.7763 1.08111 6.66804 1.08111C7.55978 1.08111 9.47729 1.01149 10.2815 1.3221C10.8176 1.53096 11.2307 1.93529 11.4468 2.46279C11.7668 3.25271 11.693 5.12708 11.693 6C11.693 6.87292 11.7668 8.74997 11.4468 9.53721Z"/>
                                </svg>
                            </a>
                            <a :href="$options.consts.VUE_APP_YOUTUBE_LINK" v-if="$options.consts.VUE_APP_YOUTUBE_LINK" target="_blank">
                                <svg width="18" height="12" viewBox="0 0 18 12" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path opacity="0.9"
                                          d="M17.2405 1.87759C17.0491 1.13853 16.4852 0.556469 15.7693 0.358938C14.4716 0 9.26795 0 9.26795 0C9.26795 0 4.06434 0 2.76661 0.358938C2.05066 0.5565 1.48679 1.13853 1.29541 1.87759C0.947693 3.21719 0.947693 6.01213 0.947693 6.01213C0.947693 6.01213 0.947693 8.80706 1.29541 10.1467C1.48679 10.8857 2.05066 11.4435 2.76661 11.6411C4.06434 12 9.26795 12 9.26795 12C9.26795 12 14.4716 12 15.7693 11.6411C16.4852 11.4435 17.0491 10.8857 17.2405 10.1467C17.5882 8.80706 17.5882 6.01213 17.5882 6.01213C17.5882 6.01213 17.5882 3.21719 17.2405 1.87759ZM7.56607 8.54972V3.47453L11.9153 6.01219L7.56607 8.54972Z"/>
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="copyright">
                    © {{ currentYear }} <a :href="$options.consts.VUE_APP_PRIVACY_LINK" target="_blank">Privacy Policy</a> |
                    <a :href="$options.consts.VUE_APP_COOKIE_LINK" target="_blank">Cookie Policy</a>
                    <a href="https://www.comodolab.it" class="ml-4 d-inline-block">Credits</a>
                </div>
            </footer>
        </div>
        <router-view v-else></router-view>
    </div>
</template>

<script>
    import AuthStorage from "../services/AuthStorage";
    import bus from "../services/Bus"

    const {
        VUE_APP_WEBSITE,
        VUE_APP_PLAY_STORE,
        VUE_APP_APP_STORE,
        VUE_APP_PRIVACY_LINK,
        VUE_APP_COOKIE_LINK,
        VUE_APP_FACEBOOK_LINK,
        VUE_APP_TWITTER_LINK,
        VUE_APP_INSTAGRAM_LINK,
        VUE_APP_YOUTUBE_LINK,
    } = process.env;

    export default {
        consts: {
          VUE_APP_WEBSITE,
          VUE_APP_PLAY_STORE,
          VUE_APP_APP_STORE,
          VUE_APP_PRIVACY_LINK,
          VUE_APP_COOKIE_LINK,
          VUE_APP_FACEBOOK_LINK,
          VUE_APP_TWITTER_LINK,
          VUE_APP_INSTAGRAM_LINK,
          VUE_APP_YOUTUBE_LINK,
        },
        mounted() {
            this.loggedIn = this.$auth.isLoggedIn();
            bus.$on('login', () => this.loggedIn = true);
            bus.$on('logout', () => this.loggedIn = false);

            // Redirect to homepage anything different
            // from vector or home page.
            if (!['/vector', '/'].includes(this.$router.currentRoute.fullPath)){
                this.$router.push('/')
            }
        },
        data() {
            return {
                loggedIn: false,
                showDropdownMenu: false
            }
        },
        methods: {
            exit() {
                this.showDropdownMenu = false;
                AuthStorage.resetTokens();
                this.goHome();
            },
            login() {
                this.showDropdownMenu = false;
                this.$login(this.$router.currentRoute.path, {deliberateAccess:true});
            },
            goHome() {
                this.showDropdownMenu = false;
                this.$router.push('/vector')
            },
            toggleMenu() {
                this.showDropdownMenu = !this.showDropdownMenu;
            },
            downloadFromAppStore(){
                this.$registerEvent('Azione', 'Click su download da App Store')
            },
            downloadFromPlayStore() {
                this.$registerEvent('Azione', 'Click su download da Play Store')
            }
        },
        computed: {
            currentYear() {
                return new Date().getFullYear();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../styles/colors.scss';

    .desktop-page {
        background: url('../assets/desktop-bg.svg') no-repeat 0 0;
        background-size: cover;
        background-attachment: fixed;
        position: relative;
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .navbar-toggler {
        border-color: rgba(255, 255, 255, .1);
        @media screen and (min-width: 768px){
            display: none;
        }
    }

    .actions {
        position: relative;
    }

    .menu-dropdown {
        @media screen and (max-width: 768px){
            display: none;
            background: #fff;
            padding: 10px;
            position: absolute;
            right: 0;
            z-index: 999;
            width: 200px;
            box-shadow: 0 0 18px rgba(0, 0, 0, 0.3);
            border-radius: 15px 0 15px 0;
            &.show {
                display: block;
            }
            a {
                font-size: 18px;
                font-weight: normal;
                display: block;
                color: $webGrey;
                background: #fff;
                border: none;
                text-decoration: none !important;
                border-radius: 5px 0 5px 0;
                svg {
                    display: none;
                }
                &:hover {
                    background: $orange;
                    color: #fff;
                }
            }

        }
    }

    .navbar-toggler-icon {
        display: inline-block;
        width: 1.5em;
        height: 1.5em;
        vertical-align: middle;
        content: "";
        background-size: 100% 100%;
        background: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 0.9)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") no-repeat center center;
    }

    .page-header {
        padding: 27px 0;
        margin-bottom: 20px;
    }

    .logo {
        img {
            width: 178px;
        }
    }

    .sticky-footer {
        margin-top: 60px;
    }

    .copyright {
        font-family: "Open Sans", serif !important;

        a {
            font-family: "Open Sans", serif !important;
        }

        background: $webGrey;
        color: #fff;
        text-align: center;
        font-size: 11.7px;
        height: 40px;
        line-height: 40px;


        a {
            color: #fff;

            &:hover {
                color: $orange;
            }
        }
    }

    .btn {
        font-family: "Open Sans", serif !important;
        font-size: 14px;
        font-weight: bold;
    }

    .user-icon {
        fill: #fff;
        vertical-align: top;
        margin-left: 10px;
        transition: fill 0.3s;
        display: inline-block;
    }

    .btn-link {
        color: #fff;

        &:hover, &:active {
            color: #fff;
        }
    }

    .btn-primary {
        background-color: $orange;
        border-color: $orange;
        color: #fff;

        &:hover, &:active {
            background: lighten($orange, 10%) !important;
            border-color: lighten($orange, 5%) !important;
        }

        &:disabled {
            background: lighten($orange, 15%);
            border-color: lighten($orange, 15%);
        }
    }

    .btn-secondary {
        background-color: transparent;
        border-color: #fff;
        color: #fff;

        &:hover, &:active {
            background: #fff;
            color: $orange;
            border-color: #fff;

            svg {
                fill: $orange;
            }
        }
    }

    .pre-footer {
        padding-bottom: 30px;
    }

    .downloads {
        img {
            max-width: 180px;
            margin-right: 10px;
        }
    }

    .socials {
        svg {
            fill: #fff;
            transition: fill 0.3s;
        }

        a {
            margin: 20px 15px;

            &:hover {
                svg {
                    fill: $orange;
                }
            }
        }
    }
</style>